import React from "react";
import { CONFIG } from "../config";
import { Reveal } from "../hooks/useReveal";

const METRICS = [
  { value: "XPTY", label: "Ticker" },
  { value: "1 : 10mg", label: "XPTY to Platinum" },
  { value: "RWA", label: "Asset Class" },
  { value: "100%", label: "Reserve-Backed" },
  { value: "Solana", label: "Blockchain" },
  { value: "24 / 7", label: "On-chain" },
];

export default function AtAGlance() {
  return (
    <section className="w-full py-[80px] lg:py-[140px]">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-[64px]">
        <Reveal>
          <span className="micro-label">At a Glance</span>
          <h2 className="mt-5 max-w-[640px] text-[32px] sm:text-[42px] lg:text-[52px] font-medium tracking-[-0.02em] leading-[1.05] text-[#F1F2EF]">
            Platinum, precisely represented.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l hairline">
          {METRICS.map((m, i) => (
            <Reveal key={m.label} delay={(i % 3) * 0.05}>
              <div className="border-b border-r hairline px-5 sm:px-6 py-8 sm:py-10">
                <div className="text-[34px] sm:text-[38px] lg:text-[46px] font-medium tracking-[-0.02em] text-[#F1F2EF] leading-none">
                  {m.value}
                </div>
                <div className="mt-4 text-[13px] text-[#A0A5A2]">{m.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
